// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3X_Oz","footer":"styles_footer__2WzB2","passCodeTooltip":"styles_passCodeTooltip__3SaW8"};